import { DMP_PAGE_COMPONENT_MAP, PAGE_MODE_MAP } from '@/config/enums';

/**
 * 传入对象返回url参数
 * @param {Object} data
 * @returns {string}
 */
export function getParam(data) {
    let url = '';
    Object.keys(data).forEach(k => {
        const value = data[k] !== undefined ? data[k] : '';
        url += `&${k}=${encodeURIComponent(value)}`;
    });
    return url ? url.substring(1) : '';
}

/**
 * 将url和参数拼接成完整地址
 * @param {string} url url地址
 * @param {Object} data json对象
 * @returns {string}
 */
export function getUrl(url, data) {
    return (url += (url.indexOf('?') < 0 ? '?' : '&') + getParam(data));
}

/**
 * 将url和参数拼接成完整地址-v2  去重，重复字段以data中为主
 * @param {string} url url地址
 * @param {Object} data { key: value }
 * @returns {string}
 */
export function getUrlV2(url, data) {
    const u = new URL(url);

    Object.keys(data).forEach(k => {
        const value = data[k] !== undefined ? data[k] : '';

        u.searchParams.set(k, value);
    });

    return u.href;
}

/**
 * style对象转为style字符串
 * @param {Object} styleObj 
 * @returns {string}
 */
export function styleObjectConverter(styleObj) {
    if (Object.prototype.toString.call(styleObj) !== '[object Object]') {
        return '';
    }
    const style = [];
    Object.keys(styleObj).forEach(key => {
        let value = styleObj[key];
        if (value !== null && value !== undefined && value !== '') {
            if (typeof value === 'number') {
                // 数值转为rpx单位
                value = `${value * 100 / 375}vw`;
            }
            style.push(
                key.replace(/([A-Z])/g, '-$1').toLowerCase() + ':' + value
            );
        }
    });
    return style.join(';');
}

/**
 * 拆分两个容器
 * @param {Array} components
 * @returns
 */
export function separateComponents(components = []) {
    const fixedComponents = [];
    const relativeComponents = [];

    components.forEach(item => {
        item.props.isFixedBottom
            ? fixedComponents.push(item)
            : relativeComponents.push(item);
    });

    return { relativeComponents, fixedComponents };
}

/**
 * 获取组件埋点名称
 * @param {*} component
 * @returns {string}
 */
function getTrackName(component = {}) {
    const { type, props = {} } = component;
    const { isFixedBottom, isQuickSubmit } = props;

    switch (type) {
        case 'form':
            if (isFixedBottom) {
                return DMP_PAGE_COMPONENT_MAP.form_float;
            } else if (isQuickSubmit) {
                return DMP_PAGE_COMPONENT_MAP.form_quick;
            } else {
                return DMP_PAGE_COMPONENT_MAP.form;
            }
        default:
            !DMP_PAGE_COMPONENT_MAP[type] &&
                console.warn(`should add a track name for component ${type}`);

            return DMP_PAGE_COMPONENT_MAP[type] || '';
    }
}

/**
 * 获取页面配置信息
 * @see https://nio.feishu.cn/docs/doccnHq59CegiiWJnVtbMqyvekf
 * @param {Object} data 落地页原始数据JSON_SCHEME
 */
export function getDmpPageInfo(data) {
    const trackComponentNames = []; // 用于埋点上报的落地页组件名称列表

    let useAuthLocation = !data.presetAreaCode && data.mode !== PAGE_MODE_MAP.other; // 是否需要获取定位授权

    // 针对mode=other的页面处理
    data.presetModel = data.presetModel || '';

    data.components.forEach((item, index) => {
        // 用于埋点上报的组件名称
        item.props.trackName = getTrackName(item);
        trackComponentNames.push(item.props.trackName);

        if (['link', 'image'].includes(item.type)) {
            item.props.targetConfig = item.props.targetConfig || {};
            if (item.props.targetConfig && item.props.targetConfig.carType) {
                // 落地页默认车型配置优先级更高
                item.props.targetConfig.carType = data.presetModel || item.props.targetConfig.carType;
                // 全系车型按ES6处理
                if (item.props.targetConfig.carType.toUpperCase() === 'ALL') {
                    item.props.targetConfig.carType = 'ES7';
                }
            }
        } else if (item.type === 'form') {
            // 对于嵌入式表单需判断是否需要定位授权
            if (!item.props.isFixedBottom && !item.props.isQuickSubmit) {
                // 是否获取定位授权
                if (
                    item.props.fields &&
                    item.props.fields.indexOf('area') >= 0
                ) {
                    useAuthLocation = true;
                }
            }
        } else if (item.type === 'award') {
            item.props.disableLocate = item.props.disableLocate || false;
        }
    });

    // 处理style
    data.components.forEach(item => {
        // 处理props.style
        item.props.style = styleObjectConverter(item.props.style);
        // 处理props.submitButton.style
        if (item.props.submitButton) {
            item.props.submitButton.style = styleObjectConverter(
                item.props.submitButton.style
            );
        }
        // 认证组件按钮样式
        if (item.type === 'corp_authentication') {
            item.props.emailAuthConfig.buttonStyle = styleObjectConverter(
                item.props.emailAuthConfig.buttonStyle
            );
        }
    });

    // for trackExposeAction: 设置component_id & position_rank
    let positionIndex = 1;
    data.components.forEach(item => {
        item.props = item.props || {};
        if (item.props.isFixedBottom) {
            item.props.positionRank = 0;
        } else {
            item.props.positionRank = positionIndex;
            positionIndex++;
        }
        item.props.componentId = item._uid || item.props.positionRank;
    });

    return {
        pageConfig: data,
        trackComponentNames,
        useAuthLocation,
        mode: data.mode
    };
}



// WEBPACK FOOTER //
// ./src/util/dmp/index.js